﻿namespace eXpress.web.header {
	$(function () {
		const openLeadTimesPopupAsync = () => {
			let dialog: core.StyleguideViewPopup;

			return eXpress.core.StyleguideViewPopup.createDialogAsync (
					{
						view: "StyleguideLeadTimesDialog",
						dialogId: "lead-times-dialog",
						forceRefresh: true
					}
				)
				.then($popup => {
					// hide maindialog cover for non ux pages
					const mainDialogCoverEl = html.querySelector<HTMLElement>(document, "#maindialogcover");
					mainDialogCoverEl && mainDialogCoverEl.classList.add('u-hide');

					dialog = new core.StyleguideViewPopup($popup);
					return dialog.openAsync()
						.then(() => {
							return undefined;
						});
				});
		};

		const mainNavigation = new components.main.MainNavigation
			(
				html.querySelector<HTMLElement>(document, ".technical-header", true),
				{
					getIconsAsync: urls => utils.getInlineSvgsAsync(urls),
					openLeadTimesPopupAsync
				}
			);
	});
}
